module.exports = __webpack_public_path__ + "static/img/アセット 10@2x.f972bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 10@2x.png
// module id = sz19
// module chunks = 1